import { render, staticRenderFns } from "./ViewPageHeader.vue?vue&type=template&id=0124dd87"
import script from "./ViewPageHeader.vue?vue&type=script&lang=js"
export * from "./ViewPageHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports